module.exports = __webpack_public_path__ + "static/img/icn_info@3x.b0a1c8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icn_info@3x.png
// module id = gcA9
// module chunks = 10